import { AchFileModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class AchFile extends DomainEntity<AchFileModelDto> {
    public createDefault(): this {
        return new AchFile({
            id: 0,
            fileContent: '',
            fileName: '',
            fileSize: '',
            success: false,
        }) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get fileContent() {
        return this.dto.fileContent;
    }

    public get fileName() {
        return this.dto.fileName;
    }

    public get fileSize() {
        return this.dto.fileSize;
    }

    public get success() {
        return this.dto.success;
    }
}
